import request from '@/utils/request'

let Pushagainst = {

    /*获取推三反一设置*/
    get_setting(data) {
        return request._get('/shop/plus.pushagainst.Setting/setting', data);
    },
    /*推三反一设置*/
    setting(data) {
        return request._post('/shop/plus.pushagainst.Setting/setting', data);
    },
     /*获取活动记录*/
     list(data) {
        return request._post('/shop/plus.pushagainst.Pushagainst/list', data);
    },
    // 获取参与人记录
    getRecord(data){
        return request._post('/shop/plus.pushagainst.Pushagainst/record', data);
    },
    getUserData(data){
        return request._post('/shop/plus.pushagainst.pushagainst/statics', data);
    },
}

export default Pushagainst;



// WEBPACK FOOTER //
// ./src/api/pushagainst.js